function clean (s) {
  return s.replace(/\n\r?\s*/g, '')
}


module.exports = function tsml (sa) {
  var s = ''
    , i = 0

  for (; i < arguments.length; i++)
    s += clean(sa[i]) + (arguments[i + 1] || '')

  return s
}


//////////////////
// WEBPACK FOOTER
// ./~/tsml/tsml.js
// module id = 271
// module chunks = 0